import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, Tag } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Barre de réservation persistante, visible uniquement sur mobile.
 * Apparaît après un léger défilement pour ne pas masquer le hero.
 */
export const MobileBookingBar: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToBooking = () => {
    const el = document.getElementById("accompagnements");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/#accompagnements");
    }
  };

  return (
    <div
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="bg-card/95 backdrop-blur-sm border-t border-border shadow-elegant px-3 py-2.5 flex items-center gap-2">
        <Button
          onClick={goToBooking}
          className="flex-1 h-11 bg-gradient-primary text-primary-foreground font-montserrat"
          aria-label="Prendre rendez-vous"
        >
          <Calendar className="w-4 h-4 mr-2" />
          Prendre RDV
        </Button>
        <Button
          variant="outline"
          className="h-11 px-3 font-montserrat"
          onClick={() => navigate("/tarifs")}
          aria-label="Voir les tarifs et accompagnements"
        >
          <Tag className="w-4 h-4 mr-1.5" />
          Tarifs
        </Button>
      </div>
    </div>
  );
};

export default MobileBookingBar;
